import * as React from 'react';
import { Container, Grid2, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from '../../setup/Navbar';
import AutoComplete from '../../../BuiltInComponent/AutoComplete';
import ButtonNormal from '../../../BuiltInComponent/ButtonNormal';
import TextFields from '../../../BuiltInComponent/TextField';
import DatePickerSelf from '../../../BuiltInComponent/DatePricker';
import HeadingText from '../../../BuiltInComponent/HeadingTest';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Table, TableHead, TableBody, TableCell, TableRow, TableContainer, Paper } from '@mui/material';
import { getSupplierList, } from '../../../features/setup/useableSlice';
import { createPDMaster, getPDData, getPDDetails, getDraftPO, createPDDetail, getCurrentStock } from '../../../features/StockManagement/Purchases/pdSlice';
import BasicAlerts from '../../../BuiltInComponent/Alert'

export default function AddPurchaseOrder() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useSelector(state => state.auth);
    const { suppliers } = useSelector(state => state.ru);
    const { returnpdID, draftPO } = useSelector(state => state.pd);

    // const [pdID, setPdID] = React.useState('');
    const [showAlert, setShowAlert] = React.useState(false);

    const [selectedPDID, setSelectedPDID] = React.useState(null);
    const [masterData, setMasterData] = React.useState({
        entDate: dayjs(new Date()).format('YYYY-MM-DD'),
        pdID: returnpdID || '',
        userID: user.userID,
        PartyCode: '',
        remarks: '',
        pdStatus: 'Pending',
        editStatus: false
    });

    const [detailList, setDetailList] = React.useState([]);

    React.useEffect(() => {
        dispatch(getDraftPO());
        dispatch(getSupplierList());
        dispatch(getCurrentStock());
    }, [dispatch]);

    React.useEffect(() => {
        const passedpdID = location.state?.pdID
        if (passedpdID) {
            dispatch(getPDData(passedpdID))
                .then(res => {
                    if (res.payload) {
                        if (res.payload.pm[0].pdStatus === 'Pending') {
                            setMasterData(prev => ({
                                ...prev,
                                pdID: res.payload.pm[0].pdID,
                                entDate: res.payload.pm[0].entDate,
                                PartyCode: res.payload.pm[0].PartyCode,
                                remarks: res.payload.pm[0].remarks,
                                pdStatus: res.payload.pm[0].pdStatus,
                                editStatus: true
                            }))
                            if (detailList.length === 0) {
                                const fetchedItems = res.payload.pd.map(item => ({
                                    ...item,
                                    quantity: item.quantity || '',
                                    delivered: item.delivered || '',
                                    poID: item.poID
                                }));
                                setDetailList(fetchedItems);
                            }
                        } else {
                            setShowAlert(true)
                            setTimeout(() => {
                                navigate('/GRN')
                            }, 3000);
                        }
                    } else {
                        setMasterData(prev => ({
                            ...prev,
                            pdID: returnpdID
                        }))
                    }
                })
        }
    }, [location.state?.pdID, navigate, dispatch, returnpdID, detailList.length]);

    const handleMasterChange = (data) => {
        const keys = Object.keys(data);
        setMasterData(prev => ({ ...prev, [keys[0]]: data[keys[0]] }));
    };

    const handlePRSelect = async (data) => {
        console.log("Selected PR Data:", data);
        const poID = data.poID;
        const alreadyAdded = detailList.some(item => item.poID === poID);
        if (alreadyAdded) {
            alert(`PO #${poID} already added.`);
            return;
        }
        setSelectedPDID(poID);
        dispatch(getPDDetails(poID)).then(res => {
            if (res.payload) {
                const fetchedItems = res.payload.map(item => ({
                    ...item,
                    quantity: item.quantity || '',
                    delivered: '',
                    poID: poID
                }));
                setDetailList(prev => [...prev, ...fetchedItems]);
            }
        });
    };

    const handleItemChange = (index, field, value) => {
        const updated = [...detailList];
        updated[index][field] = value;
        setDetailList(updated);
    };

    const saveMaster = () => {
        dispatch(createPDMaster(masterData)).then(res => {
            if (res.payload && res.payload.pdID) {
                // setPdID(res.payload.pdID);
                setMasterData(prev => ({ ...prev, pdID: res.payload.pdID }))
            }
        });
    };

    const saveDetails = () => {
        dispatch(createPDDetail({ pdID: masterData.pdID, detailData: detailList, editStatus: masterData.editStatus }));
        navigate('/GRN');
    };

    return (
        <>
            <Navbar />
            <Container>
                {showAlert && (
                    <BasicAlerts
                        msg="This Purchase Delivery Challan (GRN) is not in Delivered status and cannot be edited."
                        getCloseCommand={setShowAlert}
                    />
                )}
                <Grid2 container spacing={2}>
                    <Grid2 size={4} sx={{ marginTop: 3 }} ></Grid2>
                    <Grid2 size={4} sx={{ marginTop: 3 }} ><HeadingText text={'Purchase Delivery (GRN)'} /></Grid2>
                    <Grid2 size={4} sx={{ marginTop: 3 }} ></Grid2>
                    <Grid2 size={0.5}>
                        <KeyboardBackspaceIcon
                            sx={{
                                fontSize: 30, marginLeft: -1, color: 'white', cursor: 'pointer',
                                backgroundColor: '#1D4988', padding: 1, borderRadius: 50
                            }}
                            onClick={() => { navigate('/GRN') }} />
                    </Grid2>
                    <Grid2 size={12}>
                        <Typography sx={{
                            marginLeft: -1,
                            color: 'grey', fontSize: 18, fontWeight: 'bolder'
                        }}>Master Data</Typography>
                    </Grid2>

                    <Grid2 size={2}>
                        <DatePickerSelf name="entDate" value={masterData.entDate} onChange={handleMasterChange} />
                    </Grid2>
                    <Grid2 size={3}>
                        <AutoComplete
                            label="Select Party"
                            listData={suppliers && suppliers}
                            value={suppliers.find(p => p.PartyCode === masterData.PartyCode)}
                            onChange={handleMasterChange}
                            disabledValue={masterData.pdID ? true : false}
                        />
                    </Grid2>
                    <Grid2 size={4.5}>
                        <TextFields
                            label="Remarks"
                            name="remarks"
                            value={masterData.remarks}
                            onChange={handleMasterChange}
                            disStatus={false}
                        />
                    </Grid2>
                    <Grid2 size={2.5}>
                        <ButtonNormal text="Save PD (GRN) Master" onClick={saveMaster} />
                    </Grid2>
                    {masterData.pdID && (
                        <>
                            <Grid2 size={12}>
                                <Typography sx={{
                                    marginLeft: -1,
                                    color: 'grey', fontSize: 18, fontWeight: 'bolder'
                                }}>Detail Data</Typography>
                            </Grid2>
                            <Grid2 size={4}>
                                <AutoComplete
                                    label="Select Purchase Request"
                                    listData={draftPO && draftPO}
                                    value={draftPO.find(p => p.pdID === selectedPDID)}
                                    onChange={(data) => handlePRSelect(data)}
                                />
                            </Grid2>
                            <Grid2 size={12}>
                                <EditablePOItemTable
                                    tableData={detailList && detailList}
                                    onFieldChange={handleItemChange}
                                />
                            </Grid2>

                            <Grid2 size={2}>
                                <ButtonNormal text="Save PO Details" onClick={saveDetails} />
                            </Grid2>
                        </>
                    )}
                </Grid2>
            </Container>
        </>
    );
}



// src/BuiltInComponent/EditablePOItemTable.jsx


function EditablePOItemTable({ tableData, onFieldChange }) {
    return (
        <TableContainer component={Paper}>
            <Table size="small">
                <TableHead sx={{ backgroundColor: '#f2f2f2' }}>
                    <TableRow>
                        <TableCell>Item Code</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>Quantity</TableCell>
                        <TableCell>Rate</TableCell>
                        <TableCell>Balance</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tableData.map((row, index) => {
                        const balance = (parseFloat(row.quantity || 0) - parseFloat(row.delivered || 0)).toFixed(2);
                        return (
                            <TableRow key={index}>
                                <TableCell>{row.itemCode}</TableCell>
                                <TableCell>{row.itemDesc}</TableCell>

                                <TableCell>
                                    <TextFields
                                        name="quantity"
                                        value={row.quantity}
                                        onChange={(val) => onFieldChange(index, 'quantity', val.quantity)}
                                        disStatus={false}
                                    />
                                </TableCell>

                                <TableCell>
                                    <TextFields
                                        name="delivered"
                                        value={row.delivered}
                                        onChange={(val) => onFieldChange(index, 'delivered', val.delivered)}
                                        disStatus={false}
                                    />
                                </TableCell>

                                <TableCell>{balance}</TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
